import { FieldArray, useFormikContext } from "formik";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import SectionHeading from "../common/SectionHeading";
import DynamicFieldGroup from "../common/DynamicFieldGroup";

const INSURANCE_OPTIONS = [
  "Life/Term",
  "Health",
  "General",
  "Auto and Vehicles",
  "No any thing",
];

const InsuranceCoverage = ({ formField }) => {
  const { insurancePolicies } = formField;
  const { values, setFieldValue } = useFormikContext();
  const isSmallDevice = useMediaQuery("(max-width:600px)");

  return (
    <Box sx={{ p: isSmallDevice ? 0.5 : 1, maxWidth: 1000, mx: "auto" }}>
      <Paper
        elevation={3}
        sx={{
          p: isSmallDevice ? 2 : 3,
          position: "relative",
          border: "1px solid #e0e0e0",
          borderRadius: 3,
        }}
      >
        {/* <SectionHeading
          title="Existing Insurance Coverage Information"
          number={7}
        /> */}

        <div className="row">
          <FieldArray name={insurancePolicies.name}>
            {(arrayHelpers) => {
              const insuranceList =
                values.insuranceCoverage?.insurancePolicies || [];

              const handleCheckboxChange = (name) => {
                const index = insuranceList.findIndex((i) => i.name === name);
                const exists = index > -1;

                if (name === "No any thing") {
                  if (!exists) {
                    setFieldValue(insurancePolicies.name, [
                      { name: "No any thing" },
                    ]);
                  } else {
                    arrayHelpers.remove(index);
                  }
                } else {
                  const noAnythingIndex = insuranceList.findIndex(
                    (i) => i.name === "No any thing",
                  );
                  if (noAnythingIndex > -1)
                    arrayHelpers.remove(noAnythingIndex);

                  if (exists) arrayHelpers.remove(index);
                  else
                    arrayHelpers.push({
                      name: name,
                      providerCompanyName: "",
                      policyValue: 0,
                    });
                }
              };

              return (
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      display: "block",
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    }}
                  >
                    1. Insurance Policies
                  </Typography>

                  {INSURANCE_OPTIONS.map((name) => {
                    const index = insuranceList.findIndex(
                      (i) => i.name === name,
                    );
                    const exists = index > -1;

                    return (
                      <div
                        key={name}
                        className="col-md-12 mb-3 p-2 rounded "
                        style={{
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div className="form-check mb-0">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`insurance-${name}`}
                            checked={exists}
                            onChange={() => handleCheckboxChange(name)}
                          />
                          <Typography
                            component="label"
                            htmlFor={`insurance-${name}`}
                            sx={{
                              display: "block",
                              fontSize: { xs: "0.875rem", sm: "1rem" },
                              cursor: "pointer",
                            }}
                          >
                            {name}
                          </Typography>
                        </div>

                        {exists && name !== "No any thing" && (
                          <DynamicFieldGroup
                            showTextField={true}
                            textFields={[
                              {
                                label: "Provider Company Name",
                                value:
                                  insuranceList[index].providerCompanyName ||
                                  "",
                                onChange: (e) => {
                                  const value = e.target.value;
                                  const updated = [...insuranceList];
                                  updated[index].providerCompanyName = value;
                                  setFieldValue(
                                    insurancePolicies.name,
                                    updated,
                                  );
                                },
                                name: "text",
                              },
                            ]}
                            showSlider={true}
                            sliderValue={insuranceList[index].policyValue || 0}
                            onSliderChange={(e, newValue) => {
                              const updated = [...insuranceList];
                              updated[index].policyValue = newValue;
                              setFieldValue(insurancePolicies.name, updated);
                            }}
                            sliderMin={0}
                            sliderMax={10000000}
                            sliderStep={10000}
                            showInputField={true}
                            inputValue={insuranceList[index].policyValue || ""}
                            onInputChange={(e) => {
                              const value = Number(e.target.value) || 0;
                              const updated = [...insuranceList];
                              updated[index].policyValue = value;
                              setFieldValue(insurancePolicies.name, updated);
                            }}
                            inputLabel="Policy Value ₹"
                            inputType="number"
                            // sx={{ borderBottom: "1px solid #ccc", mt: 1}}
                          />
                        )}
                      </div>
                    );
                  })}
                </Box>
              );
            }}
          </FieldArray>
        </div>
      </Paper>
    </Box>
  );
};

export default InsuranceCoverage;
